'use strict';

window.CFC = window.CFC || {};
window.CFC.Newsletter = (function($) {
  function init() {
    var $form = $('.newsletterBanner__form');
    
    $form.on('submit', function(e) {
      submitNewsletterForm(e)
      .then(data => {
        var $form = $(this).closest('form');
        var $banner = $form.closest('.newsletterBanner');
        var $msg = $banner.find('.newsletterBanner__msg');
  
        $banner.addClass('newsletterBanner--' + data.result);
        $msg.text(data.msg);
       });
    });
    
    var $backBtn = $('.newsletterBanner .newsletterBanner__backBtn');

    $backBtn.on('click', function() {
      $(this).closest('.newsletterBanner')
        .removeClass('newsletterBanner--success')
        .removeClass('newsletterBanner--error');
    });

    
    var $newsletterBlockForm = $('.newsletterBlock form');
    
    $newsletterBlockForm.on('submit', function(e) {
      submitNewsletterForm(e)
      .then(data => {
        const block = this.closest('.newsletterBlock');
        const msgHolder = block.querySelector(`.newsletterBlock__${ data.result }`);
        msgHolder.innerText = data.msg;
        
        block.classList.remove('newsletterBlock--error');
        block.classList.remove('newsletterBlock--success');
        block.classList.add(`newsletterBlock--${ data.result }`);
       });
    });
  }
  
  /**
   * Submits to a newsletter form (with action set via CFCNewsletter.php::getSubscribeUrl).
   *
   * @return a Promise for a result in the form { result: 'success'|'error', msg: A success or error message. }
   */
  function submitNewsletterForm(e) {
    e.preventDefault();
    
    const target = e.originalTarget || e.target;

    var $form = $(target).closest('form');
    var action = $form.attr('action').replace('subscribe/post?', 'subscribe/post-json?') + '&c=?';
    
    return new Promise(resolve => { 
      $.ajax({
        url: action,
        data: $form.serialize(),
        dataType: 'jsonp',
        headers: {'Access-Control-Allow-Origin':'*'}, 
        complete: function(jqXHR) { 
          var data = jqXHR.responseJSON;
  
          if (!data || !data.result|| !data.msg) {
            data = { result: 'error', msg: "Could not subscribe to newsletter.  Please try again later." };
          }

          resolve(data);
        }
      });
    });
  }
  
  $(init);
  
  return {
    submitNewsletterForm
  }
})(jQuery);